import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { global } from '../../../app.settings';
import { AccordionService } from '../services/accordion.service';

@Component({
  selector: 'app-claim-date-search',
  templateUrl: './claim-date-search.component.html',
  styleUrls: ['./claim-date-search.component.scss']
})
export class ClaimDateSearchComponent
  implements OnInit {

  @Input() public group: FormGroup;
  @Input() public accordionGroupName: string; // = 'date';
  public readonly dateFormat: string = global.dateFormat;
  public readonly minDate: Date = new Date('1990-01-01');

  constructor(private accordionService: AccordionService) { }

  ngOnInit() {
    ['lossDateRange', 'instructionDateRange', 'contactDateRange', 'noFirstContactDate', 'visitDateRange',
      'noFirstVisitDate', 'prelimDateRange', 'lastReportDateRange', 'noPreliminaryReportDate', 'satisfactionDateRange',
      'estSettlementDateRange', 'finalReportDateRange', 'closureDateRange']
        .forEach((name) => this.accordionService.addFormControl(this.accordionGroupName, this.group, name));

    this.group.controls.noFirstContactDate.valueChanges.subscribe(value => {
      if (value) {
        this.group.controls.contactDateRange.reset();
      }
    });

    this.group.controls.noFirstVisitDate.valueChanges.subscribe(value => {
      if (value) {
        this.group.controls.visitDateRange.reset();
      }
    });

    this.group.controls.noPreliminaryReportDate.valueChanges.subscribe(value => {
      if (value) {
        this.group.controls.prelimDateRange.reset();
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-date-search/claim-date-search.component.ts